import React from 'react';
import './Footer.css'

const Footer = () => {
    return (
        <footer className="footer light-gradient">
            <div className="footer-bottom">
                <a href={'https://stats.uptimerobot.com/WaCcOuFLZs'}>Status</a>
                <p className="footer-text">A Superfroggie App</p>
                <p className="footer-copyright">&copy; 2025 Superfrogie Apps</p>
            </div>
            {/*<p className="footer-text">Golf League Tools is currently available for free during our Beta period. After*/}
            {/*  development of the app is complete the <a href="/pricing">pricing</a> will be implemented.</p>*/}
        </footer>
    )
        ;
};

export default Footer;